import { useEffect, useState } from "react";
import { ApiEndpoints } from "../../store/type/API-Endpoints";
import { getEmptySitesAPI, getGroups, getInactiveSitesAPI } from "../../Api Methods/Api";
import { Await } from "react-router-dom";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import classes from '../OfflineSites/offlineSites.module.css'
import DataManager from "../../hooks/DataManager";
import SearchBar from "../SearchView/Search/SearchBar";
import DevicesList from "../../components/GridList/DevicesList";
import { useDispatch, useSelector } from "react-redux";
import Stats2 from "../../components/UI/Stats/Stats2";
import { Button } from "primereact/button";
import ActiveSitesSearchbar from "../ActiveSites/activeSitesSearchbar";

const InactiveSites = () => {

    const [activeSites, setActiveSites] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [searchTerm, setSearchTerm] = useState("")
    const [filteredData, setFilteredData] = useState([])
    const dataManager = new DataManager();

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(100)
    const [update, setUpdate] = useState(0)
    const [showMassSettings, setShowMassSettings] = useState(false)

    const [selectedFilter, setSelectedFilter] = useState("")
    const [sortBy, setSortBy] = useState([])
    const [page, setPage] = useState(1);
    const [visibleDevices, setVisibleDevices] = useState([]);
    
    const [groups, setGroups] = useState([]) // TODO!
    const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
    const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
    const [includes, setIncludes] = useState(true)

    const [online, setOnline] = useState(0)
    const [offline, setOffline] = useState(0)
    const [deviceTag, setDeviceTag] = useState(null)
    const [deviceType, setDeviceType] = useState(0)
    const [groupName, setGroupName] = useState(null)
    const [noTag, setNoTag] = useState(0)

    const [submit, setSubmit] = useState(0)

    const [showLoadMore, setShowLoadMore] = useState(true)

    const apiData = {
        token,
        client
    }

    const HandleLoadMore = () => {
      setIsLoading(true);
  
      const getInactiveSites = async () => {
          let body = {
              "active": 0,
              "pageSize": 100,
              "pageOffset": activeSites.length, // skip already loaded rows
              "online": online,
              "offline": offline,
              "deviceTag": deviceTag,
              "deviceType": deviceType,
              "groupName": groupName,
              "noTag": noTag
          };
  
          const response = await getInactiveSitesAPI(apiData, body, dispatch);
  
          // Merge new data with existing
          setActiveSites(prevSites => [...prevSites, ...response.data[1]]);
          setFilteredData(prevSites => [...prevSites, ...response.data[1]]);
  
          // Optional: if fewer than pageSize returned, disable the button
          if (response.data[1].length < body.pageSize) {
              // e.g. setHasMore(false)
              setShowLoadMore(false)
          }
  
          setIsLoading(false);
      };
  
      getInactiveSites();
  };
  


    useEffect(() => {
        const handleDeviceFilter = () => {
            const filtered = activeSites.filter((item) =>
              Object.values(item)
                .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
            );
            dataManager.setItem('emptySitesSearchTerm', searchTerm); // Store search term
            setFilteredData(filtered); // Update filtered data
          };
        
          if (searchTerm !== dataManager.getItem('emptySitesSearchTerm')) {
            handleDeviceFilter(); // Call filtering function
          }
    }, [searchTerm])

    const getSites = async (body) => {
        const response = await getInactiveSitesAPI(apiData, body, dispatch)
        setActiveSites(response.data[1])
        setResultCount(response.data[0][0].totalCount)
        setFilteredData(response.data[1])
        setIsLoading(false)
    }

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            console.log(listOptions);
            setGroups(listOptions || []);
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    }

    useEffect(() => {
        let body = {
            "active": 0,
            "pageSize": pageSize,
            "pageOffset": 0,
            "online": online,
            "offline": offline, 
            "deviceTag": deviceTag,
            "deviceType": deviceType,
            "groupName": groupName,
            "noTag": noTag
        }

        getSites(body)
        GetGroups()
    }, [submit])

    return (
        <Await resolve={activeSites}>
          {(loadedActiveSites) => {
            return (
              <>
            <div style={{ width: "100%"}}>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <div style={{ width:"350px" }} >
                        <Stats2
                            title={"Inactive sites"}
                            value={resultCount}
                            isLoadingStats={isLoading}
                            isStatic={true}
                        />
                    </div>
                </div>
            </div>
              <div style={{ width: "100%"}}>
              {isLoading ? (
                <div style={{ display: "flex", width: "100%" }}>
                  <DeviceLoadingGrid
                    CardCount={
                      20
                    }
                  />
                </div>
              ) : (
                <>
                <div className={classes.searchContainer}>

                <ActiveSitesSearchbar
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    showFilterButton={true}
                    groups={groups}
                    online={online}
                    setOnline={setOnline}
                    offline={offline}
                    setOffline={setOffline}
                    deviceTag={deviceTag}
                    setDeviceTag={setDeviceTag}
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                    groupName={groupName}
                    setGroupName={setGroupName}
                    submit={submit}
                    setSubmit={setSubmit}
                    noTag={noTag}
                    setNoTag={setNoTag}
                    style={{
                        padding: "10px", 
                        width: "300px",    
                        fontSize: "14px",  
                        boxSizing: "border-box", 
                        borderRadius: "4px",
                    }}/>

                {searchTerm !== "" && <div>
                    <p>{filteredData.length} results</p>
                </div>}
              </div>
  
                <DevicesList
                  devices={filteredData}
                  filtering={""}
                  hideControls={true}
                  totalPages={totalPages}
                  setTotalPages={setTotalPages}
                  pageFetchedIndex={pageFetchedIndex}
                  setPageFetchedIndex={setPageFetchedIndex}
                  pageSize={filteredData.length}
                  setPageSize={setPageSize}
                  totalDevices={filteredData.length}
                  setTotalDevices={setTotalDevices}
                  groupMode={false}
                  update={update}
                  setUpdate={setUpdate}
                  offlineOnly={false}
                  isSortable={true}
                  showMassSelect={true}
                  showMassSettings={showMassSettings}
                  setShowMassSettings={setShowMassSettings}
                />
                </>
                
              )}
            </div>

            { showLoadMore && <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center', 
                textAlign: 'center',
                marginTop:"5px"
                }}>
                <Button style={{width: "100%"}}label="Load more" onClick={HandleLoadMore}/>
            </div>}
            </>
            )
          }}
        </Await>
      )
}

export default InactiveSites;